import { GetQueryProps } from 'services/api/firestore';
import { ColoringGridCollectionDto } from 'types/DTO/ColoringGridCollectionDTO';

import { useLiveData } from './useLiveData';

const DEFAULT_QUERY: GetQueryProps<ColoringGridCollectionDto> = {
  collectionPath: 'coloringGridCollections',
};

export const useColoringGridCollections = (props?: GetQueryProps<ColoringGridCollectionDto>) => {
  return useLiveData<ColoringGridCollectionDto>(props ?? DEFAULT_QUERY);
};
